import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import classnames from 'classnames';
import { appendTextToRTEState, getDefaultRTEState } from 'shared/lib/rteHelper';
import { ToolbarHeight } from 'shared/constants/FeaturedEditorConstants';
import PrompterRowHeader from 'main/components/show/cuesheet.prompter/prompterRowHeader';
import PrompterRowEditor from 'shared/components/rte/prompterRowEditor';

export default React.createClass({
  displayName: 'PrompterRow',
  mixins: [PureRenderMixin],

  getInitialState() {
    return { editorScrollTop: 0 };
  },

  componentWillReceiveProps(nextProps) {
    const { scrollTop } = this.props;
    if (nextProps.scrollTop && nextProps.scrollTop !== scrollTop) {
      this.setState({ editorScrollTop: nextProps.scrollTop });
    }
  },

  render() {
    const {
      index,
      item,
      isEditing,
      isSelected,
      loading,
      prompterItemInfoEnabled,
      editorState,
      defaultRTEText,
      width,
      height,
      zoom,
      lineHeight,
      featuredCapitalization,
      prompterTextMirror,
      prompterTextVerticalMirror,
      onCancelEdit,
      actionBarStyle,
      toolbarStyle,
      viewType,
      rowOrder,
    } = this.props;

    const itemInfoHeight = _getItemInfoHeight(index);

    const { editorScrollTop } = this.state;

    const rteEditorProps = { loading };

    if (editorScrollTop) rteEditorProps.scrollTop = editorScrollTop;
    if (isEditing)
      rteEditorProps.height = prompterItemInfoEnabled
        ? height - itemInfoHeight - ToolbarHeight
        : height - ToolbarHeight;

    const zoomClassName = this._getEditorZoomClassName(),
      lineHeightClassName = this._getEditorLineHeightClassName(),
      fontWeightClassName = this._getEditorFontWeightClassName();

    const rowEditorClasses = classnames(
      zoomClassName,
      lineHeightClassName,
      fontWeightClassName,
      'featured-fullscreen-editor-row',
      {
        'featured-editor-capitalization': featuredCapitalization,
        'featured-editor-text-mirror': prompterTextMirror && !isEditing,
        'featured-editor-text-vertical-mirror':
          prompterTextVerticalMirror && !isEditing,
        final: rowOrder.length - 1 === index,
      },
    );

    return (
      <div onBlur={this._onBlur} className={rowEditorClasses}>
        {this._getRowItemTitle(item)}
        <PrompterRowHeader
          {...{ isEditing, index }}
          actionBarStyle={actionBarStyle}
          onSave={this._onSave}
          onCancel={onCancelEdit}
        />
        <PrompterRowEditor
          {...rteEditorProps}
          readOnlyWidth={width}
          isEditing={isEditing}
          isSelected={isSelected}
          onScroll={this._setScrollTop}
          toolbarStyle={toolbarStyle}
          onSelect={this._onSelect}
          onStartEdit={this._onStartEdit}
          onWillUnmount={this._onWillUnmount}
          onStopEdit={this._onStopEdit}
          editorState={editorState}
          onExternalContentChange={this._onExternalContentChange}
          zoom={zoom}
          lineHeight={lineHeight}
          placeholder={isEditing ? '' : defaultRTEText}
          viewType={viewType}
        />
      </div>
    );
  },

  _onBlur() {
    const { columnId, onBlur, rowId } = this.props;
    const cellKey = this._getCellKey(rowId, columnId);

    onBlur(rowId, columnId, this.state[cellKey]);
  },

  _onSave() {
    const { columnId, onStopEdit, rowId } = this.props;
    const cellKey = this._getCellKey(rowId, columnId);

    onStopEdit(rowId, columnId, this.state[cellKey]);
  },

  _onSelect() {
    const { columnId, onSelect, rowId } = this.props;
    onSelect(rowId, columnId);
  },

  _onStartEdit() {
    const { columnId, onStartEdit, rowId } = this.props;
    onStartEdit(rowId, columnId);
  },

  _onStopEdit(editorState) {
    const { columnId, rowId, onStopEdit } = this.props;

    onStopEdit(rowId, columnId, editorState);
    this.setState({ editorScrollTop: 0 });
  },

  _onExternalContentChange(editorState) {
    const { columnId, rowId } = this.props;

    this._handleExternalContentChange(rowId, columnId, editorState);
  },

  _setScrollTop(e) {
    const { onScroll, isEditing } = this.props;

    if (!isEditing) return;

    this.setState({ editorScrollTop: e.target.scrollTop });
    onScroll(e);
  },

  _getRowItemTitle(item) {
    const { prompterItemInfoEnabled, index } = this.props;

    if (!item || !prompterItemInfoEnabled) return null;

    const title = this._getFeaturedTitleRTEState(item);

    return (
      <div
        data-testid={`featured-fullscreen-editor-row-item-${index}`}
        id={`featured-fullscreen-editor-row-item-${index}`}
        className="featured-fullscreen-editor-row-item"
      >
        <div className="featured-fullscreen-editor-row-item-number">
          {item.numberAdjusted}
        </div>
        <div className="featured-fullscreen-editor-row-item-separator">-</div>
        <div className="featured-fullscreen-editor-row-item-title">{title}</div>
      </div>
    );
  },

  _getFeaturedTitleRTEState(item) {
    let editorTitleState = item ? item.editorTitleState : null;
    if (!editorTitleState) return '';

    const currentContentState = editorTitleState.getCurrentContent();

    let plainText = currentContentState.getPlainText().trim();
    let withoutDoubleLineBreaks = plainText.replace(/[\r\n]{2,}/gm, '\r\n');

    return withoutDoubleLineBreaks;
  },

  _getDefaultTitleRTEState() {
    return appendTextToRTEState(getDefaultRTEState(), 'Item');
  },

  _handleExternalContentChange(rowId, columnId, editorState) {
    this.setState({ [this._getCellKey(rowId, columnId)]: editorState });
  },

  _getCellKey(rowId, columnId) {
    return `${rowId}_${columnId}`;
  },

  _getEditorZoomClassName() {
    const { zoom } = this.props;
    return `featured-editor-zoom-${zoom}`;
  },

  _getEditorLineHeightClassName() {
    const { lineHeight } = this.props;
    return `featured-editor-line-height-${lineHeight}`;
  },

  _getEditorFontWeightClassName() {
    const { fontWeight } = this.props;
    return `featured-editor-font-weight-${fontWeight}`;
  },
});

function _getItemInfoHeight(index) {
  const itemInfoElement = document.getElementById(
    `featured-fullscreen-editor-row-item-${index}`,
  );
  if (!itemInfoElement) {
    return 0;
  }
  const itemInfoHeight = parseInt(
    window.getComputedStyle(itemInfoElement).height,
    10,
  );
  return itemInfoHeight;
}
